import withAnimation from '@shared/components/utils/hoc/withAnimation';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const ChannelListSynopsisRightContainer = styled.div<{
  focused?: boolean;
}>`
  bottom: 0;
  display: flex;
  flex-direction: column;
  margin-left: ${37 * Screen.widthRatio}px;
  position: relative;
  top: ${-8 * Screen.widthRatio}px;
`;

export default withAnimation(ChannelListSynopsisRightContainer);
